import script from "./TrackedArtefacts.vue?vue&type=script&setup=true&lang=js"
export * from "./TrackedArtefacts.vue?vue&type=script&setup=true&lang=js"

import "./TrackedArtefacts.vue?vue&type=style&index=0&id=3e25cfe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e25cfe0"]])

export default __exports__